<template>
  <img :src="`${realSrc}`" alt="" />
  <!-- <el-image
    :src="`${realSrc}`"
    :fit="fit"
    rounded="true"
    >
    <div slot="error" class="image-slot">
      <slot name="error"></slot>
    </div>
  </el-image> -->
</template>

<script>
import { isExternal } from '@/utils/validate';
export default {
  name: 'ImageRemote',
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  computed: {
    realSrc() {
      if (!this.src) {
        return;
      }
      const realSrc = this.src.split(',')[0];
      if (isExternal(realSrc)) {
        return realSrc;
      }
      return process.env.VUE_APP_BASE_API + realSrc;
    },
    realWidth() {
      return typeof this.width === 'string' ? this.width : `${this.width}px`;
    },
    realHeight() {
      return typeof this.height === 'string' ? this.height : `${this.height}px`;
    },
    realSrcList() {
      if (!this.src) {
        return;
      }
      let realSrcList = this.src.split(',');
      let scrList = [];
      realSrcList.forEach((item) => {
        if (isExternal(item)) {
          return scrList.push(item);
        }
        return scrList.push(process.env.VUE_APP_BASE_API + item);
      });
      return scrList;
    },
  },
};
</script>
